import $axios from "../../api/axios";

function sendRequestAgentKitEmailApi({ params, callback }) {
  $axios
    .post(`/api/agent/requestAgentKit`, params.data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function sendRequestToJoinUConnectEmailApi({ params, callback }) {
  $axios
    .post(`/api/agent/requestUConnectKit`, params.data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  sendRequestAgentKitEmailApi,
  sendRequestToJoinUConnectEmailApi
};



// WEBPACK FOOTER //
// ./src/api/request/request.js